<template>
<div class="lzd-preview">
  <div class="lzd-preview__header">
    
    <Icon @click="winControl.openURL(img.url)" style="cursor: pointer;" size="50" color="#fff" type="ios-arrow-round-down" />
    <Icon @click="close()" style="cursor: pointer;" size="50" color="#fff" type="ios-close" />
  </div>
  <div class="lzd-preview__content">
    <div class="lzd-preview__viewer" :style="{ 'backgroundImage':'url('+ img.url +')'}" style="transform: scale(1); background-size: auto 100%;"></div>
  </div>
</div>
</template>
<script>

export default {
  data() {
    return {
      // 默认选中的值
      icon: "ios-square-outline"
    };
  },
  created() {
  },
  props: ["img"],
  computed: {
    
  },
  methods: {
    close() {
      this.$emit('preImgmsgHide');
    }
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.lzd-preview {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  background-color: rgba(0,0,0,.7);
  z-index: 99;
  display: flex;

  .lzd-preview__header {
    display: flex;
    justify-content: flex-end;
    padding: 30px;
    z-index: 3;

    .action-btn {
      color: #fff;
      margin: 0 20px;
      cursor: pointer;
    }
  }

  .lzd-preview__content {
    flex: 1 1;
    display: flex;
    padding: 30px;

    .lzd-preview__viewer {
      transform: scale(1);
      flex: 1 1;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: auto,contain;
    }
  }
  .lzd-preview__footer {
    display: flex;
    justify-content: center;
    background-color: rgba(0,0,0,.5);
    padding: 60px 50px;

    .im-components-btn {
      position: relative;
    display: inline-block;
    font-style: normal;
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    box-shadow: none;
    border-radius: 3px;
    text-align: center;
    height: 28px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 26px;
    border-width: 1px;
    }
    .im-components-btn-normal {
      border-style: solid;
      background-color: #f7f8fa;
      border-color: #c4c6cf;
    }
    .im-components-btn-primary {
      background-color: #0898ff;
      margin: 0 15px;
    }
  }
}
</style>
